export default () => {

  'ngInject';

  return {
    restrict: 'A',
    require: 'ngModel',
    link: ($scope, $element, $attrs, $ctrl) => {

      const minValidator = value => {
        const min = parseInt($attrs.vuiMin);
        if (value && parseInt(value) < min) {
          $ctrl.$setValidity('vuiMin', false);
          return undefined;
        } else {
          $ctrl.$setValidity('vuiMin', true);
          return value;
        }
      };

      $ctrl.$parsers.push(minValidator);
      $ctrl.$formatters.push(minValidator);

    }
  };
}
